
import { Button } from "../ui/button";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import SocialShare from "../shared/SocialShare";

interface FortunePreviewProps {
  generatedFortune: string;
  onPreviewClick: () => void;
}

const FortunePreview = ({ generatedFortune, onPreviewClick }: FortunePreviewProps) => {
  return (
    <div className="mt-12 bg-secondary/50 p-6 rounded-xl border border-secondary text-center">
      <h2 className="text-2xl font-light mb-6">Your Custom Fortune</h2>
      
      <div className="fortune-paper paper-texture p-6 rounded-lg inline-block mx-auto mb-8">
        <p className="text-gray-700 italic font-light text-lg">{generatedFortune}</p>
      </div>
      
      <div className="flex flex-wrap justify-center gap-3">
        <SocialShare 
          content={`${generatedFortune}`}
          title="My Custom Fortune Cookie Message"
          showCopyButton={true}
          showViewButton={true}
        />
        <Button 
          variant="secondary"
          onClick={onPreviewClick}
        >
          Preview
        </Button>
      </div>
      
      <div className="mt-8 text-center">
        <p className="text-muted-foreground">
          Want to bake real fortune cookies with your custom message?
        </p>
        <Link to="/recipe" className="text-foreground underline hover:text-cookie-dark transition-colors">
          Check out our recipe
        </Link>
      </div>
    </div>
  );
};

export default FortunePreview;
